
import ImageIndex from '../components/images/ImageIndex.vue';
import Vue from 'vue';

Vue.component('image-index', ImageIndex);

export default Vue.extend({});
